import { render, staticRenderFns } from "./LabelForm.vue?vue&type=template&id=739717ee"
import script from "./LabelForm.vue?vue&type=script&lang=js"
export * from "./LabelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports